import { ISelectItem } from "@/types";
import { ISales } from "@/types/sales";
import { User } from "./user";

export class Sales extends User {
  public constructor(props?: ISales) {
    super();
    if (!props) {
      return;
    }
    Object.assign(this, props);
  }

  public static toSelectItem(sales: ISales): ISelectItem {
    return {
      text: sales.name,
      value: sales.id,
    };
  }
}
